// import HScroll from "@koas/v-hscroll";
import CryptoJS from 'crypto-js';
import CONSTANT from '../../constants/constant'
import Multiselect from 'vue-multiselect'
import VueElementLoading from 'vue-element-loading';
import TripServices from '../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service'

export default {
  name: 'table',
  components: {
    CONSTANT,
    Multiselect,
    VueElementLoading,
  },
  props: ['rowData','podIndex'],
  data() {
    return {
      AWBLengthLimit: CONSTANT.AWB_LENGTH_LIMIT,
      MPSLengthLimit: CONSTANT.MPS_LENGTH_LIMIT,
      isBasicInfoLoading: false,
      scanAWB: '',
      scanMPS: '',
      scanDeliveredAWB: '',
      scanUndeliveredAWB: '',
      scanUndeliveredMPS: '',
      offset: 0,
      Subexpanded: false,
      awbErr: '',
      currentTab: 'firstmile',
      tripData: '',
      tmstripid: '',
      awbToBeScannedFM: 0,
      awbToBeScannedLM: 0,
      awbScannedFM: 0,
      awbScannedLM: 0,
      isListingLoaded: false,
      firtmileDocumentData: [],
      lastmileDocumentData: [],
      physicalInvoiceErr: '',
      firstmileMPSData: [],
      lastmileMPSData: [],
      documentCountFM: 0,
      mpsCountFM: 0,
      documentCountLM: 0,
      mpsCountLM: 0,
      shipmentType: "",
      lmShipmentType: '',
      lmPhysicalInvoices: '',
      podalreadyuploadErr: '',
      lmPhysicalInvoiceErr: '',
      isAWBScanning: false,
      isMPSScanning: false,
      undeliveredAWBErr: '',
      reasonSearch: null,
      podDetail: [],
      podImage: '',
      reasonlist: [],
      PODQC: "",
      imageRequired: 0,
      ODOErr: '',
      closeTripData: '',
      accordianTab: { 1: false, 2: false, 3: false },
      selectedAWB: [{
        "AWB": '',
        "Cash": '',
        "collectibleData": {
          filename: '',
          filepath: {
            Location: ''
          }
        },
      }],
      cashcollection: '',
      cashcollected: '',
      collectibledocument: {},
      collectibledoc: '',
      subaccordianTab: { 1: false, 2: false },
      expanded: false,
      showDepartTrip: false,
      depscloseTrip: false,
      VehicleCloseODOreading: '',
      physicalInvoices: "",
      ScanPalletFM: "",
      ScanPalletLM: "",
      Comments: "",
      tripStatus: '',
      scanDeliveredAWBErr: '',
      podQCErr: '',
      reasonErr: '',
      lastMpsAwbScannedData: '',
      isPalletScanCompulsory: "",
      isFMPalletScan: true,
      isLMPalletScan: true,
      fmScanPalletErr: '',
      lmScanPalletErr: '',
      showShipmentDropDown: [],
      modifyphysicalinvoice: [],
      invoiceerr: [],
      showTable: true,
      imagearray: [],
      defaultscanflag: '', //1 for AWB and 2 for MPS
      scantype: "",
      maxcomment: 50,
      imageerr: '',
      Loading: false,
      disableflag: false,
      imageLoader: false,
      ODOhidden: false,
      showCloseTripModal: false,
      AWBArr: [],
      MPSArr: [],
      MPSList: [],
      FTCAWB: [],
      FTCCashmemo: [],
      userdetail: {},
      ODOhidden: false,
      imgOpenFlag: false,
      badReason: '',
      selectedRemark: [],
      selectedBadRemarks: [],
      podRemarkArray: [],
      saveDetailsFlag: false,
      viewpod: false,
      viewpodErr: '',
      showMPS: false,
      modalData: '',
      dwsinscanawbarr: [],
      dwsawbpayload: [],
      dwsinscanawbarr: [],
      dwsawbpayload: [],
      tobescanawbarr: [],
      tobescanmpsarr: [],
      alertmsg: '',
      firstmileInvoiceData: [],
      invoiceAwb: '',
      addAwb: [],
      invoiceAwb: [],
      awbError: '',
      subtabdisabledflag: false,
      checkemptyawb: true,
      pendingInvoice: [],
      previewImageUrl: "",
      zoom: 1,
      rotation: 0,
      showImageFlag: false,
      scanDocumentMdlFlag: false,
      isScannerImageLoading: false,
      mediaStream: null,
      defaultImage: 'https://live-podimage.s3.ap-south-1.amazonaws.com/DocFile/94371190613854_P0.png',
      imageData: {
        image: '',
        image_orientation: 0
      },
      capturePhotoMdlFlag: false,
      viewCamera: false,
      images: [
        'https://live-podimage.s3.ap-south-1.amazonaws.com/DocFile/94371190613854_P0.png'

      ],
      viewScannedImage: false,
      printerList: [],
      scannerList :[],
      selectedCamera: null,
      selectedScanner: null,
      desiredWidth: 1600,
      desiredHeight: 1200,
      selectedCaptureImage: null,
      imageBlob: null,
      selectedStatus1: null,
      temppodStatusArray: [{
        id: 1,
        label: "good"
      },
      {
        id: 2,
        label: "bad"
      }
      ],
      selectedPodQc: [],
      selectedStatus1: [],
      uploadShippingImage1: '',
      uploadBrowsePodImageMdlFlag: false,
      viewUploadedImage: false,
      uploadImageEvent: '',
      showImage: false,
      selectedPodImage: [],
      selectedImages: [],
      currentIndex: 0,
      displayViewImage: false,
      selectedBrowsedFileArray: [],      
      //Camera modal
      selectedCameraCapturedPodImage: [],
      displayCameraCapturedImages: false,      
      //Scanner Images
      selectedPodImagesByScanner: [],
      displayScannerImages: false,
      isGetDeviceLoader: false,
      previewScannerImageUrl : '',
      isCameraImageLoader : false,
      showNotes: true,
      showTooltip: false,

      allCapturedPodImagesArray: [],
      viewUploadedPodImages: false,
      viewCapturedPodsImageSrc: '',
      viewCapturedPodLoader: false,
      podPayloadToSaveInDb: {},
      selectedTableRowDataArray: '',
      podBadRemarkComments: {},
      disabledDeleteImageButton:[],
      disableBrowseImageButton: [],
      disableCameraImageButton: [],
      disableScannerImageButton: [],
      enableDeleteImageDisableClass:[],
      enableBrowseImageDisableClass: [],
      enableCameraImageDisableClass: [],
      enableScannerImageDisableClass: [],
      enableActionItems: [],
      disableAction: [],
      disableClassForPodReason: [],
      enablePodResonDropdown: [],
      viewBrowseImageUploadButton: false,
      viewCameraImageUploadButton: false,
      viewScannerImageUploadButton: false,
      selectedRowIndex: 0,
      isGetDeviceLoader: false,
      commentLoader: false,
      badRemarkShippingId: '',
      badPodComment: [],
      viewpodCommentModal: false,
      currentSelectedRemark: '',
      currentSelectedRemarkDetails: {},
      selectedAllImages: [],
      podReviewFieldImageStatus: false,
      uploadHubImageStatus: null,
      podDetail : [this.rowData],
      maxDisplayedOptions: 5,
      disabledSaveDeliveredPodBtn: false,
      notReviewedHubImageShipmentArray: [],
      disabledActionButtonDiv: false,
      disabledLmCloseTrip: false,
      viewUploadedHubImages: []     
      
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    setname(id, name){
        return name+id;
      },
      badResonDeselect(index, $event) {
        let parts = this.podDetail[this.selectedRowIndex].comments.split(',');
        let commentText = ''
        if ($event.id == 4) {
          commentText = 'Upload Document'
        } else {
          commentText = $event.label
        }
        let modifiedParts = parts.filter(part => !part.startsWith(`${commentText}:`));
        let resultString = modifiedParts.join(',');
        this.podDetail[this.selectedRowIndex].comments = resultString
      },
      toggleShowAllOptions(index) {
        this.$set(this.podDetail, index, {
          selectedOptions: this.podDetail[index].badpodreason,
          showAllOptions: !this.podDetail[index].showAllOptions,
        });
      },
      closePodCommentModal() {
        let currentValue = this.currentSelectedRemarkDetails.event.id
        let currentIndex = this.currentSelectedRemarkDetails.index 
        this.viewpodCommentModal = false;
                this.commentLoader = false
    
    },
      async savePodComment() {
        this.commentLoader = true
        if (this.badPodComment == "") {
            this.$alertify.error("Please Enter Comments")
            this.commentLoader = false
            return false
        }
        let commentKey = ''
        if (this.currentSelectedRemarkDetails.event.id == 4) {
          commentKey = "Upload Document"
        } else {
          commentKey = this.currentSelectedRemarkDetails.event.label
        }
        let commentObject = `${commentKey}:${this.badPodComment}`
  
        this.podDetail[this.selectedRowIndex].comments = this.podDetail[this.selectedRowIndex].comments != 'NA' ? `${this.podDetail[this.selectedRowIndex].comments},${commentObject} `: commentObject
        // this.podBadRemarkComments[this.selectedRowIndex] = this.podBadRemarkComments[this.selectedRowIndex] ? `${this.podBadRemarkComments[this.selectedRowIndex]},${commentObject}` : commentObject
        this.$alertify.success("Comments Added Successfully")
        this.viewpodCommentModal = false
        this.badPodComment = ""
        this.commentLoader = false
        this.commentLoader = false
    },
      viewPodFieldImages(podData, index) {
        if (podData && podData.podurl ) {
          this.$viewerApi({
            images: podData.podurl.destinationpodimg,
          })
        }
        this.podDetail[index].reviewstatus = true 
      },   
    async viewPodHubImages(podData, index) {  
      let hubImagesArray = []
      if (this.podDetail[index].documentscanned == 3) {
        // hubImagesArray = this.podDetail[index].uploadedHubImage
        for (let i = 0; i < this.podDetail[index].uploadedHubImage.length; i++) {
          const element = this.podDetail[index].uploadedHubImage[i];
          let inputPayload = {
            filepath : element
          }
          let presignUrlData = await TripServices.generatePresignUrl(inputPayload)  
          if (presignUrlData && presignUrlData.data.code == 200) {
            hubImagesArray.push(presignUrlData.data.data)
          }
        }
      } else {
        for (let i = 0; i < this.podDetail[index].uploadedPod.length; i++) {
          const element = this.podDetail[index].uploadedPod[i];
          let inputPayload = {
            filepath : element
          }
          let presignUrlData = await TripServices.generatePresignUrl(inputPayload)
          if (presignUrlData && presignUrlData.data.code == 200) {
            hubImagesArray.push(presignUrlData.data.data)
          }
        }
      }  
      if (hubImagesArray.length > 0) {        
        this.viewAdditionalDocImage = hubImagesArray  
        this.$viewerApi({
          images: this.viewAdditionalDocImage,
        })
      } else {
        this.$alert('No Pod Uploaded', "", "error");
      }
    },

      viewSinglePodImage(url) {
        this.viewCapturedPodsImageSrc = url
      },
      closeOpenModals(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          // Close or hide the div
          this.uploadBrowsePodImageMdlFlag = false
          this.capturePhotoMdlFlag = false
          this.scanDocumentMdlFlag = false
          this.viewUploadedPodImages = false
        }
      },
      async OnClickDeletePod(rowData, index) {
        this.selectedRowIndex = index
        this.$confirm("Are you sure you want to delete the Pod's.", '', 'question').then(async () => {
          let allImage = [...this.podDetail[index].selectedBrowsedPodsToUploadS3,
                          ...this.podDetail[index].selectedCameraPodsToUploadS3,
            ...this.podDetail[index].selectedScannedPodsToUploadS3
          ]
          let uploadedS3Images = [
            ...this.podDetail[index].uploadedPod
          ]        
          if (uploadedS3Images.length > 0) {
            let payload = {
              podImages : uploadedS3Images
            }
            let result = await TripServices.deletePodImages(payload)
            this.podDetail[index].disableBrowseImageButton = false
            this.podDetail[index].disableCameraImageButton = false
            this.podDetail[index].disableScannerImageButton = false
            this.podDetail[index].selectedBrowsedPodsToUploadS3Save = []
            this.podDetail[index].selectedBrowsedPodsToUploadS3 = []
            this.podDetail[index].selectedScannedPodsToUploadS3 = []
            this.podDetail[index].selectedCameraPodsToUploadS3 = []       
            this.podDetail[index].presignHubImage = []
            this.viewUploadedHubImages = []
            this.selectedCameraCapturedPodImage = []
            this.selectedPodImagesByScanner = []
            this.selectedBrowsedFileArray = []
            this.selectedPodImage = []
            this.selectedAllImages = []
            this.podDetail[index].uploadedPod = []
            this.$alertify.success("All selected images are deleted successfully");
          } else {
            this.$alertify.error("Not Found any Images to Delete");
          }
        });     
      },
      podQcValidation(val, podQc, selectedBadRemark, comments,index) {      
        if (podQc == '2') {
          if (!selectedBadRemark || selectedBadRemark.length === 0) {
            const errorMessage = "User must select a bad pod reason if PodQC is bad";
            this.$alertify.error(errorMessage);
            return { valid: 0, message: errorMessage };
          }
        }
      
        return { valid: 1, message: "" };
      },
      openBrowserUploadModal(val, podQc, selectedBadRemark, comments, index) {
        this.performAction()
        this.podDetail = [this.rowData]
        this.selectedRowIndex = 0 

        let validationResult = this.podQcValidation(val, podQc, selectedBadRemark, comments,index)
        if (validationResult.valid) {
          this.viewBrowseImageUploadButton = this.podDetail[index].selectedBrowsedPodsToUploadS3.length>0 ? true : false
          this.selectedPodImage = this.podDetail[index].selectedBrowsedPodsToUploadS3
          this.selectedTableRowDataArray = val
          this.scanDeliveredAWB = val.awb
          this.Loader = false
          this.isScannerImageLoading = false
          this.uploadBrowsePodImageMdlFlag = true
        }    
      },
      performAction() {
        this.$emit('customEvent', this.rowData);
      },
      async openCapturePhotoModal(val, podQc, selectedBadRemark, comments, index) {
        this.performAction()
        this.podDetail = [this.rowData];
        this.selectedRowIndex = 0
        this.selectedCamera = null
        this.isScannerImageLoading = false
        this.isCameraImageLoader =  false
        await this.fetchCameraList()  
        let validationResult = this.podQcValidation(val, podQc, selectedBadRemark, comments)
        if (validationResult.valid) {
          this.viewCameraImageUploadButton = this.podDetail[index].selectedCameraPodsToUploadS3.length > 0 ? true : false
          this.selectedCameraCapturedPodImage = this.podDetail[index].selectedCameraPodsToUploadS3
          this.selectedTableRowDataArray = []
          this.selectedTableRowDataArray = val
          this.Loader = false
          this.capturePhotoMdlFlag = true
          this.isScannerImageLoading = false
          this.scanDeliveredAWB = val.awb
          // this.onclickCaptureImage()
        }
      },
      async openScannerModal(val, podQc, selectedBadRemark, comments, index) { 
        this.performAction()
        this.podDetail = [this.rowData] 
        this.selectedRowIndex = 0    
        this.selectedScanner = null
        this.selectedPodImagesByScanner = this.podDetail[index].selectedScannedPodsToUploadS3
        let validationResult = this.podQcValidation(val, podQc, selectedBadRemark, comments)
        if (validationResult.valid) {
          this.viewScannerImageUploadButton =  this.podDetail[index].selectedScannedPodsToUploadS3.length > 0 ? true : false
          this.selectedTableRowDataArray = []
          this.Loader = false
          this.isScannerImageLoading = false
          this.selectedTableRowDataArray = val
          this.scanDocumentMdlFlag = true
          this.scanDeliveredAWB = val.awb
        }
      },
      closeImage() {
        this.showImage = false;
      },
      removeImage(index) {
        this.performAction()
        this.podDetail = [this.rowData] 
        this.selectedRowIndex = 0    
        this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.splice(index, 1)
        this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3Save.splice(index,1)
        this.previewImageUrl = ''
        this.selectedPodImage = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3
        if (this.selectedPodImage.length <= 0) {
          this.viewBrowseImageUploadButton = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length>0 ? true :false
          this.disabledActionButtonDiv = false
          this.displayViewImage = false
          this.previewImageUrl = ''
        }
      },
     
      viewImage(index) {
        this.disabledActionButtonDiv = true
        this.previewImageUrl = index
      },
      viewCameraImage(cameraimage) {
        this.disabledActionButtonDiv = true
        this.imageData.image =  cameraimage
      },
      viewScannerImage(ScannedImage) {
        this.disabledActionButtonDiv =  true
        this.previewScannerImageUrl = ScannedImage
      },
      closeBrowseUploadModal() {
        this.disabledActionButtonDiv = false
        if (this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length>0) {        
          this.viewBrowseImageUploadButton =true
        }
        this.uploadBrowsePodImageMdlFlag = false
        this.previewImageUrl = ''
        this.viewUploadedImage = false
        this.displayViewImage = false
        // this.selectedPodImage = []
      },
      closeViewUploadedImageModal() {
        this.viewUploadedPodImages = false
        this.previewImageUrl = ''
        this.viewUploadedImage = false
        this.uploadBrowsePodImageMdlFlag = false
        // this.selectedPodImage = []
      },
      addBrowsedPodImageInList() {
        this.selectedPodImage.push(this.previewImageUrl)
      },
      
      showScannerTooltip() {
        this.showTooltip = true
      },
      async BrowsePodImage(e) {
        this.disabledActionButtonDiv = true;
        this.selectedImages = []
        if (!/\.(jpg|png|jpeg)$/.test(e.target.files[0].name.toLowerCase())) {
            this.isLoading = false;
            this.$refs.files.value=null;
            return this.$alert('Selected File Format Is Incorrect.', "", "error");
        }
        if (this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length>2 || e.target.files.length >3) {
          this.isScannerImageLoading = false
          return this.$alert('You Can Select Only 3 Pod Images',"","error")
        }
        this.filename = e.target.files[0].name;
        this.isScannerImageLoading = true;
        this.selectedBrowsedFileArray = e.target.files;      
        this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3Save.push(...e.target.files)
        this.viewBrowseImageUploadButton = true
        for (let i = 0; i < this.selectedBrowsedFileArray.length; i++) {
          const file = this.selectedBrowsedFileArray[i];
          if (file.type.startsWith('image/')) {
            const imageUrl = URL.createObjectURL(file);
            this.previewImageUrl = imageUrl;          
            this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.push(imageUrl)
            this.selectedPodImage = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3;
            this.displayViewImage = true
          }
        }
        this.isScannerImageLoading = false;
       
      },
      async uploadBrowsedFilesInS3() {
        if (this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3 && this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3.length > 0) {
          this.isListingLoaded = true
          let uploadFile = this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3Save
  
          this.imagearray = []
          let formData = new FormData();
          /*Add the form data we need to submit*/
          for (let key in uploadFile) {
            if (key >= 0) {
              if (uploadFile[key].type != "image/jpeg" &&
                uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
                this.$alertify.error("Please upload only valid file format");
                this.isListingLoaded = false
                return false
              }
            }
            if (key == 'length' && uploadFile[key] > 3) {
              this.$alertify.error("You Can Select Only 3 Pod Images");
              this.isListingLoaded = false
              return false
            }
            if (uploadFile[key].size > (1024 * 1024 * 3)) {
              this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
              this.isListingLoaded = false
              return false
            } else {
              formData.append("file", uploadFile[key]);
            }
          }
          formData.append("awb",this.podDetail[this.selectedRowIndex].awb );
          let result = await TripServices.UploadPODImage(formData)
          if (result.data.code == 200) {
            this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 = []
            this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 = []
            this.podDetail[this.selectedRowIndex].disabledDeleteImageButton=true
            this.podDetail[this.selectedRowIndex].disableBrowseImageButton = false
            this.podDetail[this.selectedRowIndex].disableCameraImageButton = true
            this.podDetail[this.selectedRowIndex].disableScannerImageButton = true
              this.isListingLoaded = false
              let tempPresignedArray = []
              let tempUploadPod = []
              result.data.data.map(obj => {
                this.imagearray.push(obj.Location)
                tempUploadPod.push(obj.Location)              
                tempPresignedArray.push(obj.PresignUrl)
              })
            this.$alertify.success("Images uploaded successfully !");
            this.podDetail[this.selectedRowIndex].uploadedPod = tempUploadPod
            this.podDetail[this.selectedRowIndex].presignHubImage = tempPresignedArray
            this.uploadHubImageStatus = this.selectedRowIndex
            this.viewBrowseImageUploadButton = false
            this.imageerr = ''          
          }
          else {
            this.$alertify.error("Images could not be uploaded.");
            this.isListingLoaded = false
          }
          if (!this.podPayloadToSaveInDb[this.scanDeliveredAWB]) {
            this.podPayloadToSaveInDb[this.scanDeliveredAWB] = { awb:this.scanDeliveredAWB,podQc:this.selectedTableRowDataArray.podqc,badpodreason:this.selectedTableRowDataArray.badpodreason,comments:this.selectedTableRowDataArray.comments,podimages:this.imagearray };
          } else {
            console.log("Key ALready Exits");
          }
          this.isListingLoaded = false
        }
        else {
          this.isListingLoaded = false
          this.$alertify.error("Please Select POD Images");
        }
        this.isListingLoaded = false
      }, 
      async uploadScannerCapturedBinaryImage() {
        let images = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3
        if (images && images.length > 0) {
          this.isGetDeviceLoader = true
          let uploadFile = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3;
          this.imagearray = []
          let formData = new FormData();
          for (let key in uploadFile) {
            var binaryData = uploadFile[key]            
                formData.append("file", binaryData);
            }
            formData.append("awb", this.scanDeliveredAWB);
            let result = await TripServices.UploadCameraBinaryImage(formData)
          if (result.data.code == 200) {
            this.viewScannerImageUploadButton = false
            this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 = []
            this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3 = []
            this.podDetail[this.selectedRowIndex].disabledDeleteImageButton=true
            this.podDetail[this.selectedRowIndex].disableBrowseImageButton = true
            this.podDetail[this.selectedRowIndex].disableCameraImageButton = true
            this.podDetail[this.selectedRowIndex].disableScannerImageButton = false
              this.isGetDeviceLoader = false
              let tempPresignedArray = []
              let tempUploadedImages = []
              result.data.data.map(obj => {
                this.imagearray.push(obj.Location)
                tempUploadedImages.push(obj.Location)
                this.allCapturedPodImagesArray.push(obj.PresignUrl)
                tempPresignedArray.push(obj.PresignUrl)
                this.uploadHubImageStatus = this.selectedRowIndex
              })
              this.uploadHubImageStatus = this.selectedRowIndex
              this.podDetail[this.selectedRowIndex].uploadedPod = tempUploadedImages
              this.podDetail[this.selectedRowIndex].presignHubImage = tempPresignedArray
              this.$alertify.success("Images uploaded successfully !");
                    this.imageerr = ''
            }
            else{
              this.$alertify.error("Images could not be uploaded.");
              this.isGetDeviceLoader = false
          }
          if (!this.podPayloadToSaveInDb[this.scanDeliveredAWB]) {
            this.podPayloadToSaveInDb[this.scanDeliveredAWB] = { awb:this.scanDeliveredAWB,podQc:this.selectedTableRowDataArray.podqc,badpodreason:this.selectedTableRowDataArray.badpodreason,comments:this.selectedTableRowDataArray.comments,podimages:this.imagearray };
          } else {
            console.log("Key ALready Exits");
          }
            this.isGetDeviceLoader = false
        }
        else{
          this.isGetDeviceLoader = false
          this.$alertify.error("Please Select Pod Images");
          // this.awbErr = 'Please Scan AWB'
        }
        this.isGetDeviceLoader = false
      }, 
      async uploadCameraCapturedBinaryImage() {
        if (this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 && this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3.length > 0) {
          this.isListingLoaded = true
          let uploadFile = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
          this.imagearray = []
          let formData = new FormData();
            /*Add the form data we need to submit*/
          for (let key in uploadFile) {
            var binaryData = uploadFile[key]            
                formData.append("file", binaryData);
            }          
            formData.append("awb", this.scanDeliveredAWB);
            let result = await TripServices.UploadCameraBinaryImage(formData)
          if (result.data.code == 200) {
            this.podDetail[this.selectedRowIndex].selectedBrowsedPodsToUploadS3 = []
            this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 = []
            this.podDetail[this.selectedRowIndex].disabledDeleteImageButton =true
            this.podDetail[this.selectedRowIndex].disableBrowseImageButton = true
            this.podDetail[this.selectedRowIndex].disableCameraImageButton = false
            this.podDetail[this.selectedRowIndex].disableScannerImageButton = true
              this.isListingLoaded = false
            let tempPresignedArray = []
            let tempUploadedImages = []
              result.data.data.map(obj => {
                this.imagearray.push(obj.Location)
                tempUploadedImages.push(obj.Location)
                this.allCapturedPodImagesArray.push(obj.PresignUrl)
                tempPresignedArray .push(obj.PresignUrl) 
              })
              this.uploadHubImageStatus = this.selectedRowIndex
              this.podDetail[this.selectedRowIndex].uploadedPod = tempUploadedImages
              this.podDetail[this.selectedRowIndex].presignHubImage = tempPresignedArray 
              this.$alertify.success("Images uploaded successfully !");
              this.viewCameraImageUploadButton =  false
                    this.imageerr = ''
            }
            else{
              this.$alertify.error("Images could not be uploaded.");
              this.isListingLoaded = false
            }
            this.isListingLoaded = false
        }
        else{
          this.isListingLoaded = false
          this.$alertify.error("Please Select Pod Images");
        }
        if (!this.podPayloadToSaveInDb[this.scanDeliveredAWB]) {
          this.podPayloadToSaveInDb[this.scanDeliveredAWB] = { awb:this.scanDeliveredAWB,podQc:this.selectedTableRowDataArray.podqc,badpodreason:this.selectedTableRowDataArray.badpodreason,comments:this.selectedTableRowDataArray.comments,podimages:this.imagearray };
        } else {
          console.log("Key ALready Exits");
        }
        this.isListingLoaded = false
      }, 
     
      onChangePodQcStatus(event, index) {
        if (event) {
            if (event.id == "1")
            {               
                this.enablePodResonDropdown[index] = true
                this.disableClassForPodReason[index] = 'disableAction' 
                this.podDetail[index].badpodreason = []
            } else {
                this.enablePodResonDropdown[index] = false
                this.disableClassForPodReason[index] =''  
            }
        }
    },
    async loadScannedImageByScanner() {
        this.isGetDeviceLoader = true;      
        if (this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 && this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.length<=2 ) {
          const encodedString = encodeURIComponent(this.selectedScanner.id);
          let result = await TripServices.fetchScannedImage(encodedString)
         // Simulate an image loading delay (you would replace this with actual image loading logic)
         if (result && result.valid) {
           if (this.selectedPodImagesByScanner && this.selectedPodImagesByScanner.length<=2) {
             this.previewScannerImageUrl =  `data:image/jpeg;base64,${result.data.image}` ;
            //  this.selectedPodImagesByScanner.push(`data:image/jpeg;base64,${result.data.image}`)          
             this.isGetDeviceLoader = false;
             this.displayScannerImages = true
             this.viewScannedImage = true
             this.previewScannerImageUrl = ""
             this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.push(`data:image/jpeg;base64,${result.data.image}`)
             this.selectedPodImagesByScanner = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3
             this.viewScannerImageUploadButton = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.length >0 ? true :false
           } else {
            this.isGetDeviceLoader = false; 
             this.$alert("You Can Select only 3 Images",'Pod Validation', "error");
           }      
         } else {
           this.isGetDeviceLoader = false;
             this.displayScannerImages = true
             this.viewScannedImage = true
             this.$alert("Error While Scanning POD Image",'', "error")
         }
        } else {
          this.isGetDeviceLoader = false; 
          this.$alertify.error("You Can Select Only 3 Pod Images")
        }     
      },    
      async showMessage() {
        this.isScannerImageLoading = false
        this.viewScannedImage =true
      },    
      confirmImage() {
        this.savePODDetailTest(this.selectedBadRemarks)
      },
    async rotateScannedImage() {
        this.rotation += 90;
      },
      zoomIn() {
        this.zoom += 0.1;
      },
      zoomOut() {
        if (this.zoom > 0.1) {
          this.zoom -= 0.1;
        }
      },
      closeImagePreview() {
        this.scanDocumentMdlFlag = false
        this.previewImageUrl = false
        this.isScannerImageLoading = false
      },
      resetZoomAndRotation() {
        this.zoom = 1;
        this.rotation = 0;
      },
      closeOverlay() {
        this.showImageFlag = false
      },
      handleWheel(event) {
        if (event.deltaY > 0) {
          this.zoomOut();
        } else {
          this.zoomIn();
        }
        event.preventDefault();
      },
      inited (viewer) {
        this.$viewer = viewer
      },
      previewImage() {
        this.showImageFlag =true
      },
      closeTakePhotoModal() {
        this.disabledActionButtonDiv = false
        this.viewCameraImageUploadButton = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
        this.imageData.image = ""
        this.selectedCamera = null
        this.viewCamera = false
        this.capturePhotoMdlFlag = false
        // this.selectedCameraCapturedPodImage = []
        this.stopCameraStream()
      },
      removeScannerCapturedImage(index) {   
        this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3.splice(index, 1);
        this.selectedPodImagesByScanner =this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3
        if (this.selectedPodImagesByScanner.length <= 0) {
          this.viewScannerImageUploadButton = this.podDetail[this.selectedRowIndex].selectedScannedPodsToUploadS3 > 0 ? true : false
          this.disabledActionButtonDiv = false
          this.displayCameraCapturedImages = false
          this.imageData.image = ''
          this.previewScannerImageUrl = ''
        }
      },
      removeCameraCapturedImage(index) {  
        this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3.splice(index, 1)
        this.selectedCameraCapturedPodImage =  this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
        if (this.selectedCameraCapturedPodImage.length <= 0) {
          this.stopCameraStream()
          this.selectedCamera = null
          this.viewCameraImageUploadButton = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3 > 0 ? true : false
          this.viewCameraImageUploadButton = false
          this.disabledActionButtonDiv = false
          this.displayCameraCapturedImages = false
          this.imageData.image = ''
        }
      },  
      closeScannerModal() {
        this.selectedScanner = null
        this.disabledActionButtonDiv = false
        this.previewScannerImageUrl = ''
        // this.selectedPodImagesByScanner = []
        this.scanDocumentMdlFlag = false
      },
      onClickCameraRefresh() {
        this.fetchCameraList()
      },
      onClickScannerRefresh() {
        this.fetchScannerList()
      },
     async  onChangeCamera(selectedEvent) {
       try {
         this.isCameraImageLoader = true
         this.disabledActionButtonDiv = true
          const constraints = {
            video: {
              deviceId: { exact: selectedEvent.deviceId },
              width: { min: 640, ideal: 1600 },
              height: { min: 400, ideal: 1200 },
              aspectRatio: { ideal: 1.7777777778 },
            }          
          };
          await navigator.mediaDevices.getUserMedia(constraints)
            .then(mediaStreamres => {
              this.viewCamera = true
              this.$nextTick(() => {
                this.$refs.video.srcObject = mediaStreamres;
                this.$refs.video.play()
                this.mediaStream = mediaStreamres 
              });
                                   
            }) 
            this.isCameraImageLoader = false
        } catch (error) {
          console.error('Error starting camera stream:', error);
        }
      }, 
      async  onChangeScanner(selectedEvent) {
        try {
          this.disabledActionButtonDiv = true;
         } catch (error) {
           console.error('Error starting camera stream:', error);
         }
       },
      async onclickCaptureImage() {
        try {
          this.viewCamera = true
          const constraints = {
            video: { deviceId: { exact: this.selectedCamera } },
          };
          navigator.mediaDevices.getUserMedia(constraints)
          .then(mediaStream => {
                  this.$refs.video.srcObject = mediaStream;
                  this.$refs.video.play()
                  this.mediaStream = mediaStream                   
          }) 
        } catch (error) {
          console.error('Error starting camera stream:', error);
        }      
      },
      async uploadCameraCaptureImage() {
        if (this.scanDeliveredAWB) {
          this.isListingLoaded = true
          let uploadFile = this.selectedCaptureImage;
          this.imagearray = []
            let formData = new FormData();
            formData.append("file", uploadFile);
            formData.append("awb", this.scanDeliveredAWB);
            let result = await TripServices.UploadcameraImage(formData)
            if (result.data.code == 200) {
              result.data.data.map(obj => {
                this.imagearray.push(obj.Location)
              })
              this.$alertify.success("Images uploaded successfully !");
                    this.imageerr = ''
            }
            else{
              this.$alertify.error("Images could not be uploaded.");
              this.isListingLoaded = false
            }
            this.isListingLoaded = false
        }
        else{
          this.isListingLoaded = true
          this.$alertify.error("Please scan AWB");
          // this.awbErr = 'Please Scan AWB'
          this.isListingLoaded = false
        }
      },
      async captureCameraImage() {
        try {
          this.isCameraImageLoader = true
          if (this.selectedCameraCapturedPodImage && this.selectedCameraCapturedPodImage.length <= 2) {
            const mediaStreamTrack = this.mediaStream.getVideoTracks()[0]
            const imageCapture = new window.ImageCapture(mediaStreamTrack)
            const captureSettings = {
              width: this.desiredWidth,
              height: this.desiredHeight,
              format: 'image/jpeg' // specify the desired image format
            };
            // Apply the settings to the ImageCapture object
            imageCapture.track.applyConstraints({ advanced: [captureSettings] })
            let reader = new FileReader();
            return await imageCapture.takePhoto().then(blob => {
              reader.readAsDataURL(blob)
              const canvas = document.createElement('canvas');
              canvas.width = this.$refs.video.videoWidth;
              canvas.height = this.$refs.video.videoHeight;
              canvas.getContext('2d').drawImage(this.$refs.video, 0, 0, canvas.width, canvas.height);
              canvas.toBlob(blob => {
                this.selectedCaptureImage = new File([blob], 'captured_image.png');
              }, 'image/png');
              this.displayCameraCapturedImages = true
              reader.onload = () => {
                this.imageData.image = reader.result;
                // this.selectedCameraCapturedPodImage.push(reader.result)
                this.imageData.image = ""
                this.isCameraImageLoader = false
                this.viewCameraImageUploadButton = true
                this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3.push(reader.result)
                this.selectedCameraCapturedPodImage = this.podDetail[this.selectedRowIndex].selectedCameraPodsToUploadS3
              }
              this.isCameraImageLoader =false
            })
          } else {
            this.imageData.image = ""
            this.isCameraImageLoader = false
            this.$alertify.error("You Can Select only 3 Pod Image");
          }
        } catch (error) {
          this.isCameraImageLoader = false
        }
       
  
      },
      stopCameraStream() {
        if (this.mediaStream) {
          const tracks = this.mediaStream.getTracks();
          tracks.forEach(track => track.stop());
          this.$refs.video.srcObject = null;
          this.mediaStream = null;
        }
      },
    rotateImage() {
        this.imageData.image_orientation = this.imageData.image_orientation + 90; 
      },
      cancelScannedImage() {
        this.previewScannerImageUrl = ''
      },
    cancelCameraCapturedImage() {
        this.imageData.image = null;
        this.showCameraModal = true;
        navigator.mediaDevices.getUserMedia({video: true})
        .then(mediaStream => {
                this.$refs.video.srcObject = mediaStream;
                this.$refs.video.play()
                this.mediaStream = mediaStream                   
        }) 
      },
      async uploadBrowsePodImage() {
        let formData = new FormData();
            formData.append("awb", this.AWB)
            formData.append("userName",this.userName)
        if(this.imageEvent){
                  formData.append("checked", true)
                  let uploadEvent = this.imageEvent
                  if (uploadEvent) {
                      let uploadFile = uploadEvent.target.files;
                      this.imagearray = []
                      /*Add the form data we need to submit*/
                      for (let key in uploadFile) {
                          if (key >= 0) {
                              if (uploadFile[key].type != "image/jpeg" &&
                                  uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png") {
                                  this.$alertify.error("Please upload only valid file format");
                                  this.isLoading = false
                                  return false
                              }
                          }
                          if (key == 'length' && uploadFile[key] > 3) {
                              this.$alertify.error("Please upload maximum 3 file");
                              this.isLoading = false
                              return false
                          }
                          if (uploadFile[key].size > (1024 * 1024 * 3)) {
                              this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
                              this.isLoading = false
                              return false
                          } else {
                              formData.append("file", uploadFile[key]);
                          }
                      }
                      //api --call
                      let result = await TripServices.uploadPodData(formData)
                      if (result.data.data.code == 200) {
                          this.$alertify.success("Images uploaded successfully !");
                      } else {
                          this.$alertify.error("Images could not be uploaded.");
                          this.isLoading = false
                      }
                      this.isLoading = false
                  } else {
                      this.$alertify.error("Please Upload File again");
                      this.isLoading = false
                  }
                  this.reUploadPodModal = false;
                  this.resetReupload()
              }else{
                  this.$alertify.error("Please select a file");
              }
      },
      uploadImage() {
        this.uploadCameraCaptureImage()
        // axios({ method: "POST", "url": API_IMAGE_ENDPOINT, "data": this.imageData})
        //   .then(response => {
        //           console.log("image upload response",response);
        //             this.response = response.data;    
        //          })
      },
      async uploadScannedImage() {
        if (this.scanDeliveredAWB) {
          this.isListingLoaded = true
          let uploadFile = event.target.files;
          this.imagearray = []
            let formData = new FormData();
            /*Add the form data we need to submit*/
            for (let key in uploadFile) {
              if(key >= 0 ){
                if(uploadFile[key].type != "image/jpeg" &&
              uploadFile[key].type != "image/jpg" && uploadFile[key].type != "image/png")
              {
                this.$alertify.error("Please upload only valid file format");
                this.isListingLoaded = false
                return false
              }
              }
              if (key == 'length' && uploadFile[key] > 3) {
                this.$alertify.error("Please upload maximum 3 file");
                this.isListingLoaded = false
                return false
              }
              if (uploadFile[key].size > (1024 * 1024 * 3)) {
                this.$alert(`${uploadFile[key].name} size is greater than 3MB`, "", "error");
                this.isListingLoaded = false
                return false
              } else {
                formData.append("file", uploadFile[key]);
              }
            }
            formData.append("awb", this.scanDeliveredAWB);
            let result = await TripServices.UploadPODImage(formData)
            if (result.data.code == 200) {
              result.data.data.map(obj => {
                this.imagearray.push(obj.Location)
              })
              this.$alertify.success("Images uploaded successfully !");
              this.imageerr = ''
            }
            else{
              this.$alertify.error("Images could not be uploaded.");
              this.isListingLoaded = false
            }
            this.isListingLoaded = false
        }
        else{
          this.isListingLoaded = true
          this.$alertify.error("Please scan AWB");
          // this.awbErr = 'Please Scan AWB'
          this.isListingLoaded = false
        }
      },
      openViewer(index) {
        this.$refs.viewer.view(index);
      },
      async fetchCameraList() {
        try {
          await navigator.mediaDevices.getUserMedia({ video: true });
          this.isGetDeviceLoader = true
          const devices = await navigator.mediaDevices.enumerateDevices();
          this.printerList = devices.filter(device => device.kind === 'videoinput');
          this.isGetDeviceLoader = false
        } catch (error) {
          this.isGetDeviceLoader = false
          console.error('Error fetching camera list:', error);
        }
      }, 
      setname(id, name){
        return name+id;
      },
      async fetchScannerList() {
        try {
          this.isGetDeviceLoader = true
          this.scannerList = []
          let getScannerList = await TripServices.fetchInstalledScannerList()
          if (getScannerList.valid) {
            const scannerList = getScannerList.data.scanners.split('\n').filter(line => line.startsWith('device'));
            const scanners = scannerList.map(line => {
                const match = line.match(/device\s`(.*)'/);
                return match ? match[1] : null;
            }).filter(scanner => scanner !== null);
            var select = document.getElementById("scannerSelect");
            scanners.forEach(scanner => {
              this.scannerList.push({id:scanner,label:scanner})
            });
            this.isGetDeviceLoader = false
        }
        } catch (error) {
          this.isGetDeviceLoader = false
          console.error('Error fetching camera list:', error);
        }
      },
      downloadImage(index) {
        // Implement image download logic here
        // Example using FileSaver.js:
        const image = this.images[index];
        const xhr = new XMLHttpRequest();
        xhr.responseType = 'blob';
        xhr.onload = () => {
          const blob = new Blob([xhr.response], { type: 'image/jpeg' });
          saveAs(blob, `image_${index + 1}.jpg`);
        };
        xhr.open('GET', image);
        xhr.send();
      },
  
      async savePODDetailTest(selectedRemark){	
        let podBadRemark = []	
        if(selectedRemark){
        for (let k = 0; k < selectedRemark.length; k++) {
          const element = selectedRemark[k]; 
          let badRemark = this.podRemarkArray.find(value => value.id == element)                        
          if (badRemark) {
          podBadRemark.push(badRemark.remark)
          }                                                       
        }
        }
          if(this.checkErrForPOD()){
            return false
          }
        this.saveDetailsFlag=true;
          this.imgOpenFlagFunction();
          this.isListingLoaded = true
          let input = {
            "tripid":this.parentObj.tripId,
            "parentawb":this.scanDeliveredAWB,
            "allocationtype":this.currentTab=='lastmile'?"LM":"FM",
            "podquality":this.PODQC,
            "comments":this.Comments
          }
          if(this.PODQC == 'bad'){
            input.badpodreason= podBadRemark.toString()
            input.podimages= [this.previewImageUrl]
          }
          else
          input.podimages= [this.previewImageUrl]
          let result = await TripServices.savePOD(input);
          if(result.data.code == 200){
            this.$alertify.success(result.data.message);
            this.clearData()
            this.getPODDetailAgainstTrip()
            this.toggleCheck(2);
            this.accordianTab[2] = true
            // this.accordianTab[1] = false;
            // this.subaccordianTab[1]=true;
          }else{
            this.$alertify.error(result.data.message);
          }
          this.isListingLoaded = false
        this.viewpod = false
        this.clearData()
        this.saveDetailsFlag=false;
        },
       async saveReuplodedImage(){
        this.performAction()
        this.podDetail = [this.rowData];
        this.selectedRowIndex = 0
        let inputPayload = {
          tripid : this.podDetail[this.selectedRowIndex].tripid,
          parentawb : this.podDetail[this.selectedRowIndex].awb,
          allocationtype : 'LM',
          podquality : 'good',
          badpodreason : 'test',
          podimages : this.podDetail[this.selectedRowIndex].uploadedPod
        }
        let data = await TripServices.saveReuploadedPod(inputPayload)
        if (data.data.code == 200) {
          this.$alertify.success("POD Saved Successfully")
          await this.$emit('updateList', this.rowData);
        }else{
          this.$alertify.error(data.data.message)
        }
        
       }
  
  }
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/podUploadComponent/podUploadComponent.component.js